import styled from "styled-components";

export const StyledMyNotifications = styled.div`
  /* overflow-y: auto; */
`;
